(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const media = window.matchMedia('(max-width:1199px)');
  const placeSwitcher = () => {
    const switcher = document.getElementById('cvc-switcher-manual-desktop');
    const mobileSlot = document.getElementById('dg-mobile-localization');
    const desktopSlot = document.querySelector('store-header .header__secondary-links > .header__icon-list');
    const destination = media.matches ? mobileSlot : desktopSlot;
    if (switcher && destination && switcher.parentElement !== destination) destination.prepend(switcher);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeSwitcher, {once:true});
  else placeSwitcher();
  media.addEventListener('change', placeSwitcher);
  document.addEventListener('shopify:section:load', placeSwitcher);
})();

/* DG 2026-11-02 ust menu — asagi kaydirinca kayarak gizlenir */
(() => {
  const sec = document.querySelector('.shopify-section--header');
  if (!sec || !sec.querySelector('store-header[sticky]')) return;
  const ESIK = 160;  // bu kadar kaydirilmadan gizleme yok
  const PAY = 5;     // kucuk titremeler sayilmaz
  let son = window.scrollY, bekliyor = false;
  const serbest = () => {
    if (sec.querySelector('[aria-expanded="true"]')) return false;  // acik mega menu
    if (sec.matches(':hover')) return false;                        // fare header uzerinde
    if (document.documentElement.classList.contains('prevent-scroll')) return false;
    return true;
  };
  const isaretle = (gizli) => {
    sec.toggleAttribute('data-gizli', gizli);
    // SEPETE EKLE cubugu gibi --header-height'e dayanan ogeler icin isaret
    document.documentElement.toggleAttribute('data-header-gizli', gizli);
  };
  const uygula = () => {
    bekliyor = false;
    const y = Math.max(0, window.scrollY), fark = y - son;
    if (Math.abs(fark) < PAY) return;
    son = y;
    if (!serbest()) { isaretle(false); return; }
    if (fark > 0 && y > ESIK) isaretle(true);
    else if (fark < 0) isaretle(false);
  };
  window.addEventListener('scroll', () => {
    if (!bekliyor) { bekliyor = true; requestAnimationFrame(uygula); }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
